/**
 * Delivery module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AdminDeliveryOptions from '@src/Delivery/Pages/Fields/AdminDeliveryOptions.vue';
import AdminDeliverySubject from '@src/Delivery/Pages/Fields/AdminDeliverySubject.vue';
import GridDeliverySubject from '@src/Delivery/Pages/Fields/GridDeliverySubject.vue';
import GridDeliveryProvider from '@src/Delivery/Pages/Fields/GridDeliveryProvider.vue';
import ShippingSelect from '@src/Delivery/Pages/Fields/ShippingSelect.vue';

export const setup = (app: App<Element>): void => {
    app.component('AdminDeliveryOptions', AdminDeliveryOptions);
    app.component('AdminDeliverySubject', AdminDeliverySubject);
    app.component('GridDeliverySubject', GridDeliverySubject);
    app.component('GridDeliveryProvider', GridDeliveryProvider);
    app.component('ShippingSelect', ShippingSelect);
};
